import {CleanConsole} from '@eaboy/clean-console';
import 'bootstrap';
import 'vue-material/dist/vue-material.min.css';
import loggingDevInfo from '@/services/log-dev-info';
import i18n from '@/plugins/i18n';
import EventBus from '@/plugins/event-bus';
import filters from '@/plugins/filters';
import SharedComponents from '@/plugins/shared-components';
import SnackbarProto from '@/plugins/snackbar-prototype';
import router from './router';
import store from './store';
import VueTippy, {TippyComponent} from 'vue-tippy';
import VueMaterial from 'vue-material';
import App from './App.vue';
import Vue from 'vue';

import VueShepherd from 'vue-shepherd';
Vue.use(VueShepherd);

if (process.env.NODE_ENV === 'production') {
	CleanConsole.init({
		debugLocalStoregeKey: 'clear-console-debug',
	});
}

// Ignore using of angular web components inside vue components
Vue.config.ignoredElements = ['web-component'];

// vue-material error when selecting from dropdown
Vue.config.errorHandler = (err, vm, info) => {
	if (err.message !== "Cannot read property 'badInput' of undefined") {
		loggingDevInfo(err, 'error');
	}
};

Vue.config.productionTip = true;

// register components globally
Vue.use(SharedComponents);
Vue.use(EventBus);
Vue.use(SnackbarProto);
Vue.use(filters);
Vue.use(VueMaterial);
Vue.use(VueTippy);

Vue.component('tippy', TippyComponent);
document.documentElement.classList.remove('md-theme-default');

store.dispatch('handleStartUpCookie');

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('.app');
